var map = {
	"./bodyicons_accident.png": 2282,
	"./bodyicons_accident_dm.png": 2590,
	"./bodyicons_alcohol.png": 1135,
	"./bodyicons_alcohol_calc.png": 6443,
	"./bodyicons_alcohol_calc_dm.png": 437,
	"./bodyicons_alcohol_dm.png": 3289,
	"./bodyicons_alcohol_plus.png": 440,
	"./bodyicons_beer.png": 4528,
	"./bodyicons_beer_calc.png": 1351,
	"./bodyicons_beer_calc_dm.png": 8737,
	"./bodyicons_beer_dm.png": 6573,
	"./bodyicons_beer_drinks.png": 3481,
	"./bodyicons_beer_drinks_dm.png": 2731,
	"./bodyicons_beer_plus.png": 876,
	"./bodyicons_death.png": 7343,
	"./bodyicons_death_dm.png": 3305,
	"./bodyicons_formula.png": 4739,
	"./bodyicons_formula_fr.png": 6064,
	"./bodyicons_hurt.png": 1818,
	"./bodyicons_hurt_dm.png": 1550,
	"./bodyicons_licence.png": 6760,
	"./bodyicons_licence_dm.png": 6860,
	"./bodyicons_minus.png": 8325,
	"./bodyicons_minus_dm.png": 6791,
	"./bodyicons_plus.png": 5357,
	"./bodyicons_plus_dm.png": 3359,
	"./bodyicons_snaps.png": 4882,
	"./bodyicons_snaps_calc.png": 1688,
	"./bodyicons_snaps_calc_dm.png": 4588,
	"./bodyicons_snaps_dm.png": 1862,
	"./bodyicons_snaps_drinks.png": 3678,
	"./bodyicons_snaps_drinks_dm.png": 4482,
	"./bodyicons_snaps_plus.png": 5295,
	"./bodyicons_wine.png": 6662,
	"./bodyicons_wine_calc.png": 4836,
	"./bodyicons_wine_calc_dm.png": 4104,
	"./bodyicons_wine_dm.png": 7898,
	"./bodyicons_wine_drinks.png": 3746,
	"./bodyicons_wine_drinks_dm.png": 9974,
	"./bodyicons_wine_plus.png": 5635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4416;